import {CBARStandardMaterial} from "./CBARStandardMaterial";

export class CBARPaintMaterial extends CBARStandardMaterial {
    protected get isPaint() {
        return true;
    };
}